var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m9.59 4.6.06-.07a1.83 1.83 0 0 1 2.58 0l10.18 10.18a1.83 1.83 0 0 1 0 2.58L12.23 27.47a1.83 1.83 0 0 1-2.58 0l-.06-.07a1.83 1.83 0 0 1 0-2.58L18.41 16 9.59 7.18a1.83 1.83 0 0 1 0-2.58"}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
